import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/shared/user.service';

@Component({
  selector: 'app-notification-master',
  templateUrl: './notification-master.component.html',
  styleUrls: ['./notification-master.component.css']
})
export class NotificationMasterComponent {

  constructor() { }
  
}
